import axiosIns from "@/api/axios";

export const GET_ALL_DATA = (args) => {
    console.log(args)
    return axiosIns.get(`/notification?${args}`);
};

export const ADD_DATA = (args) => {
    return axiosIns.post(`/notification`, args);
};

export const UPDATE_DATA = (args) => {
    return axiosIns.put(`/notification/${args.id}`, args.data);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/notification/${id}`);
};
